import { type MutableRefObject, useEffect } from 'react'
import {
	hasSupport,
	updatePositioningWithLib
} from 'shared/polyfills/positioning'

import type { ActionsStore } from './store'

/**
 * Fallback for unsupported browsers
 */
export function useLegacyPosition<E extends HTMLElement = HTMLElement>(
	menuRef: MutableRefObject<HTMLDivElement | null>,
	store: ActionsStore<E>
) {
	useEffect(() => {
		if (menuRef.current === null || hasSupport) {
			return
		}

		let unsubscribe: (() => void) | null = null

		const menu = menuRef.current

		const unobserve = store.trigger.subscribe(async () => {
			unsubscribe?.()
			const current = store.trigger.value

			if (current) {
				unsubscribe = await updatePositioningWithLib(current, menu)
			}
		})

		return () => {
			unobserve()
			unsubscribe?.()
		}
	}, [menuRef, store])
}
